//React-router v6 routes config

import Root from "../Root";
import { Navigate } from "react-router-dom";
import AclRoutes from "./AclRoutes";
import { useSelector } from "react-redux";

import Login from "../modules/user/views/Login";
import Register from "../modules/user/views/Register";
import RecoverPwd from "../modules/user/views/RecoverPwd";
import ConfirmAccount from "../modules/user/views/ConfirmAccount";
import NewConfirmation from "../modules/user/views/NewConfirmation";
import AuthProvider from "../modules/identity/provider/AuthProvider";
import NoAuthProvider from "../modules/identity/provider/NoAuthProvider";
import Profile from "../modules/user/views/Profile";
import Users from "../modules/user/views/Users";
import UsersData from "../modules/user/views/UsersData";
import Analytics from "../modules/pos/views/Analytics";
import PointOfSales from "../modules/pos/views/PointOfSales";
import PointOfSale from "../modules/pos/views/PointOfSale";
import PointOfSaleData from "../modules/pos/views/PointOfSaleData";
import Questions from "../modules/pos/views/Questions";
// import Contacts from "../modules/contact/views/Contacts";
// import Conversations from "../modules/conversation/views/Conversations";
// import WacGatewayNumbers from "../modules/wac-number/views/WacGatewayNumbers";
// import WacPosNumbers from "../modules/wac-number/views/WacPosNumbers";
// import WacGatewayTemplates from "../modules/wac-number/views/WacGatewayTemplates";
// import WacPosTemplates from "../modules/wac-number/views/WacPosTemplates";
// import WfAgents from "../modules/workflow/views/WfAgents";

// const Profile = lazy(() => import("../modules/user/views/Profile"));
// const Users = lazy(() => import("../modules/user/views/Users"));
// const UsersData = lazy(() => import("../modules/user/views/UsersData"));
// const Analytics = lazy(() => import("../modules/pos/views/Analytics"));
// const PointOfSales = lazy(() => import("../modules/pos/views/PointOfSales"));
// const PointOfSale = lazy(() => import("../modules/pos/views/PointOfSale"));
// const PointOfSaleData = lazy(() => import("../modules/pos/views/PointOfSaleData"));
// const Questions = lazy(() => import("../modules/pos/views/Questions"));


function HomePage({ children }) {
  const roleName = useSelector((state) => state.identityReducer?.identity?.role?.label?.toUpperCase())

  const isAdmin = () => {
    return (roleName === 'SUPERADMIN' || roleName === 'ADMIN')
  }

  return <Navigate to={isAdmin() ? "/analytics" : "/pos-list"} />
}

const AppRoutes = [
  {
    path: "/",
    element: <Root />,
    // errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <HomePage />, //if you don't have an <HomePage /> component then redirect to another route with <Navigate to="/xxx" /> 
      },
      {
        path: "login",
        element: <NoAuthProvider><Login /></NoAuthProvider>,
      },
      {
        path: "register",
        element: <NoAuthProvider><Register /></NoAuthProvider>,
      },
      {
        path: "recovery",
        element: <NoAuthProvider><RecoverPwd /></NoAuthProvider>,
      },
      {
        path: "confirm",
        element: <NoAuthProvider><ConfirmAccount /></NoAuthProvider>,
      },
      {
        path: "confirm/:code",
        element: <NoAuthProvider><ConfirmAccount /></NoAuthProvider>,
      },
      {
        path: "new-confirmation",
        element: <NoAuthProvider><NewConfirmation /></NoAuthProvider>,
      },
      { 
          path: '/users',
          element: <AuthProvider aclRoutes={AclRoutes}><Users /></AuthProvider>
      },
      { 
        path: '/user/:id',
        element: <AuthProvider aclRoutes={AclRoutes}><Profile /></AuthProvider>
      },
      { 
        path: '/profile',
        element: <AuthProvider aclRoutes={AclRoutes}><Profile /></AuthProvider>
      },
      { 
        path: '/analytics',
        element: <AuthProvider aclRoutes={AclRoutes}><Analytics /></AuthProvider>
      },
      { 
        path: '/users/data',
        element: <AuthProvider aclRoutes={AclRoutes}><UsersData /></AuthProvider>
      },
      { 
        path: '/questions',
        element: <AuthProvider aclRoutes={AclRoutes}><Questions /></AuthProvider>
      },
      { 
        path: '/pos/:id/data',
        element: <AuthProvider aclRoutes={AclRoutes}><PointOfSaleData /></AuthProvider>
      },
      { 
        path: '/pos/:id',
        element: <AuthProvider aclRoutes={AclRoutes}><PointOfSale /></AuthProvider>
      },
      { 
        path: '/pos',
        element: <AuthProvider aclRoutes={AclRoutes}><PointOfSale /></AuthProvider>
      },
      { 
        path: '/pos-list',
        element: <AuthProvider aclRoutes={AclRoutes}><PointOfSales /></AuthProvider>
      },

      // { 
      //     path: '/conversations',
      //     element: <AuthProvider aclRoutes={AclRoutes}><Conversations /></AuthProvider>
      // },
      // { 
      //     path: '/sign_number',
      //     element: <AuthProvider aclRoutes={AclRoutes}><WacGatewayNumbers /></AuthProvider>
      // },
      // {
      //     path: '/sign_number/:gid/pdv_number',
      //     element: <AuthProvider aclRoutes={AclRoutes}><WacPosNumbers /></AuthProvider>
      // },
      // {
      //     path: '/sign_number/:gid/template',
      //     element: <AuthProvider aclRoutes={AclRoutes}><WacGatewayTemplates /></AuthProvider>
      // },
      // {
      //     path: '/sign_number/:gid/template/:id',
      //     element: <AuthProvider aclRoutes={AclRoutes}><WacGatewayTemplates /></AuthProvider>
      // },
      // {
      //     path: '/sign_number/:gid/pdv_number/:pid/template',
      //     element: <AuthProvider aclRoutes={AclRoutes}><WacPosTemplates /></AuthProvider>
      // },
      // {
      //     path: '/sign_number/:gid/pdv_number/:pid/template/:id',
      //     element: <AuthProvider aclRoutes={AclRoutes}><WacPosTemplates /></AuthProvider>
      // },
      // {
      //     path: '/workflow/:id',
      //     element: <AuthProvider aclRoutes={AclRoutes}><WfAgents /></AuthProvider>
      // },
      // {
      //     path: '/workflow',
      //     element: <AuthProvider aclRoutes={AclRoutes}><WfAgents /></AuthProvider>
      // },
    ],
  },
];

export default AppRoutes;